import {env} from '@px/helper/env';
import {mockUtil} from '@px/helper/moc';
import {clearApiHostNationCondition} from '@px/helper/localized-site';

const HOST = import.meta.env?.VITE_DEV_HOST || (env.isLocal ? 'phemex.com' : clearApiHostNationCondition(location.hostname));
const mockPrefix = mockUtil.getMockPrefix();

export const SERVICES = {
  API: ['https://api10', HOST].join(calcSeparator(HOST)) + mockPrefix,
  WS: [`wss://ws10`, HOST].join(calcSeparator(HOST)) + mockPrefix,
  STATIC_URL: 'https://static.phemex.com',
  TEST_NET: genTestNetUrl(),
  IMG_URL: 'https://img.phemex.com',
};

function genTestNetUrl() {
  if (env.isTestNet) {
    return location.origin;
  }

  return 'https://testnet.phemex.com';
}

function calcSeparator(hostname) {
  return hostname.split('.').length === 2 ? '.' : '-';
}
